// Generated by GitHub Copilot
import { Link } from '@tanstack/react-router'
import { useTranslation } from 'react-i18next'
import { Building2, LockKeyhole, LogOut } from 'lucide-react'
import User from '#core/entities/auth/users/User.ts'
import { useUserState } from '#core/state/UserState.ts'
import { CompanyLockReason } from './company-lock-reason.tsx'

/**
 * Shown instead of a company the user belongs to but cannot open with this login: names the
 * company, explains each lock reason with the action that lifts it, and offers the way out.
 *
 * @param companyId The locked company's code or UUID.
 */
export function CompanyUnlockScreen({ companyId }: { companyId: string }) {
  const { t } = useTranslation(['auth', 'navigation'])
  const userState = useUserState()
  const companies = User.memberCompanies(userState.user)
  const normalized = companyId.toLowerCase()
  const company = companies.find((c) => c.id.toLowerCase() === normalized || c.segment.toLowerCase() === normalized)

  return (
    <div className="d-flex flex-column align-items-center justify-content-center text-center min-vh-100 p-4">
      <LockKeyhole size={64} className="text-secondary mb-4" aria-hidden="true" />
      <h3 className="fw-bold mb-2">{company?.name ?? companyId}</h3>
      <p className="text-secondary mb-4" style={{ maxWidth: '32rem' }}>{t('auth:companyLock.intro')}</p>

      <div className="d-flex flex-column gap-3 w-100 mb-4" style={{ maxWidth: '32rem' }}>
        {userState.lockReasons(companyId).map((reason) => (
          <CompanyLockReason key={reason} reason={reason} companySegment={company?.segment ?? companyId} />
        ))}
      </div>

      <div className="d-flex flex-wrap justify-content-center gap-2">
        {companies.length > 1 && (
          <Link to="/" className="btn btn-outline-secondary d-inline-flex align-items-center gap-2">
            <Building2 size={18} aria-hidden="true" />
            {t('auth:companyLock.otherCompany')}
          </Link>
        )}
        <Link to="/logout" className="btn btn-outline-secondary d-inline-flex align-items-center gap-2">
          <LogOut size={18} aria-hidden="true" />
          {t('navigation:appNav.logout')}
        </Link>
      </div>
    </div>
  )
}
